<template>
  <div v-loading="loading">
      <div class="card-header d-flex justify-content-between">
        <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; gap: 20px">
          <el-input @change="filterTeamLeadIndex" clearable placeholder="Tên chỉ số" v-model="filters.name" />
          <el-select v-model="filters.departmentId" clearable @change="filterTeamLeadIndex" multiple filterable collapse-tags placeholder="Chọn phòng ban">
            <el-option
                v-for="item in departments"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="filters.quarter" clearable @change="filterTeamLeadIndex" placeholder="Chọn quý">
            <el-option
                v-for="item in quarterOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker
              v-model="filters.year"
              format="yyyy" class="w-100"
              value-format="yyyy"
              type="year" @change="filterTeamLeadIndex"
              placeholder="Chọn năm">
          </el-date-picker>
        </div>
        <HeaderManageIndexTeamLead @getListManageIndexTeamLead="getListTeamLeadIndex"/>
      </div>
    <div class="card-body bg-white">
      <div class="example mb-10">
        <TableTeamLeadIndex :data-team-lead-index="teamLeadIndexList" :page="page" @getListTeamLeadIndex="getListTeamLeadIndex"/>
        <div id="paginate" class="edu-paginate mx-auto d-flex justify-content-center">
          <paginate v-model="page" :page-count="lastPage" :page-range="3" :margin-pages="1" :click-handler="changePage"
                    :prev-text="'Trước'" :next-text="'Sau'" :container-class="'pagination b-pagination'" :pageLinkClass="'page-link'"
                    :next-link-class="'next-link-item'" :prev-link-class="'prev-link-item'" :prev-class="'page-link'"
                    :next-class="'page-link'" :page-class="'page-item'">
          </paginate>
        </div>
        <div class="position-absolute mt-3" style="right: 40px;"> Tổng số bản ghi: <b
            style="color: rgb(54, 153, 255);">{{
            total ? total : 0
          }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import HeaderManageIndexTeamLead from "@/view/pages/manage-team-lead-index/component/HeaderManageIndexTeamLead.vue";
import {GET_TEAM_LEAD_INDEX_LIST} from "@/core/services/store/okrs/okr.module";
import {quarterOptions} from "@/common/define";
import TableTeamLeadIndex from "@/view/pages/manage-team-lead-index/component/TableTeamLeadIndexList.vue";
import {GET_DEPARTMENT} from "@/core/services/store/user/users.module";
import {TeamLeadIndex} from "@/view/pages/manage-team-lead-index/model/TeamLeadIndex";

export default {
  name: 'ManageTeamLeadIndex',
  components: {TableTeamLeadIndex, HeaderManageIndexTeamLead },
  data() {
    return {
      page: 1,
      loading: false,
      currentQuarter: 1,
      quarterOptions,
      lastPage: 1,
      teamLeadIndexList: [],
      departments: [],
      total: 0,
      filters: {
        name: null,
        departmentId: null,
        quarter: null,
        year: null
      },
    }
  },

  methods: {
    changePage(obj) {
      this.page = obj
      this.getListOkr();
    },
    getCurrentQuarter() {
      const month = Number(moment().format('M'));
      this.currentQuarter = Math.ceil(month / 3)
    },
    filterTeamLeadIndex() {
      this.page = 1
      this.getListTeamLeadIndex()
    },
    getListTeamLeadIndex() {
      this.loading = true
      const payload = {
        name: this.filters.name,
        department_id: this.filters.departmentId,
        quarter: this.filters.quarter ?? this.currentQuarter,
        year: this.filters.year ?? Number(moment().format('YYYY'))
      }
      this.$store.dispatch(GET_TEAM_LEAD_INDEX_LIST, payload).then(res => {
        if (!res.error) {
          const data = res.data
          this.teamLeadIndexList = data.data.map(item => new TeamLeadIndex(item)) ?? [];
          this.total = data.total;
          this.page = data.current_page;
          this.lastPage = data.last_page
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => this.loading = false)
    },
    getListDepartment() {
      this.$store.dispatch(GET_DEPARTMENT).then(res => {
        if (!res.error) {
          this.departments = res.data ?? []
        }
      })
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý chỉ số team lead", name: 'ManageTeamLeadIndex'},
      {title: "Quản lý"}
    ]);
    this.getCurrentQuarter()
    this.getListDepartment()
    this.getListTeamLeadIndex()
  },
}
</script>

<style scoped>

</style>